import React, { useEffect } from "react";
import styled from "styled-components";
import Navbar from "../component/Header.js/Navbar/Navbar";
import Footer from "../component/Footer/Footer";
import { Link } from "react-router-dom";

const StoreLocator = () => {
    const MainBox = styled.div`
    height: fit-content;
    padding: 4rem 4rem;
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    position: relative;
    @media only screen and (max-width: 1220px) {
      width: 100%;
      padding: 1rem;
    }
  `;

    return (
        <>
            <Navbar />
            <MainBox>
                <h2>Store Locator</h2>
                <h4>Warehouse:</h4>
                <p>
                    <strong>Address:</strong> Lane No 1 Durga Vihar Mehuwala, Harbhaj Wala, Dehradun, Uttarakhand 248018<br />
                    <strong>Email:</strong> <a href="mailto:care@samriddhiindia.com">care@samriddhiindia.com</a><br />
                    <strong>Phone:</strong> <a href="tel:+919520782777">+91 95207 82777</a> (Customer Support, Mon-Sat, 10 AM – 7 PM)<br/>
                    <strong>Closed:</strong> 10:00 AM – 09:30 PM
                </p>
                <h4>Out Let:</h4>
                <p>
                    <strong>Address:</strong> Pacific Mall, Near, Rajpur Rd, Jakhan, Dehradun, Uttarakhand 248001<br />
                    <strong>Email:</strong> <a href="mailto:care@samriddhiindia.com">care@samriddhiindia.com</a><br />
                    <strong>Phone:</strong> <a href="tel:+919520782777">+91 95207 82777</a> (Customer Support, Mon-Sat, 10 AM – 7 PM)<br/>
                    <strong>Closed:</strong> 10:00 AM – 09:30 PM
                </p>
            </MainBox>
            <Footer />
        </>
    );
};

export default StoreLocator;
